require('../../modules/es6.string.iterator');
require('../../modules/es6.array.from');
module.exports = require('../../modules/_core').Array.from;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/fn/array/from.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/fn/array/from.js
// module chunks = 6